<script>
    export default {
        name: 'vue-title',
        props: ['title'],
        created () {
            var tenantName = document.querySelector('title').getAttribute('tenant');
            document.title = tenantName + ' - ' +  this.title;
        },
        watch: {
            title () {
                // only used when the title changes after page load
            var tenantName = document.querySelector('title').getAttribute('tenant');
            document.title = tenantName + ' - ' +  this.title;
            }
        },
        render () {
        },
    }
</script>